/* eslint-disable*/
import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faDownload,
  faPencil,
  faTrash,
  faChevronLeft,
  faChevronRight,
  faSortUp,
  faSortDown,
  faSort,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/UserManagement.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { API_URL } from "../../config";
import axios from "axios";
import { PermissionWrapper, hasPermission } from "../../helpers/permission.js";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";
import usePersistedState from "../../Subscriber/usePersistedState.jsx";


const FieldPermissionWrapper = ({ field, children }) => {
  const hasFieldViewPermission = hasPermission(field, "view");
  return hasFieldViewPermission ? children : null;
};

const UserManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const successMessage = location.state?.successMessage;

  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [statusFilter, setStatusFilter] = usePersistedState(
    "user_statusFilter",
    ""
  );
  const [nameFilter, setNameFilter] = usePersistedState("user_nameFilter", "");
  const [mobileFilter, setMobileFilter] = usePersistedState(
    "user_mobileFilter",
    ""
  );
  const [emailFilter, setEmailFilter] = usePersistedState(
    "user_codeFilter",
    ""
  );
  const [designationFilter, setDesignationFilter] = usePersistedState(
    "user_designationFilter",
    ""
  );
  const [categoryFilter, setCategoryFilter] = usePersistedState(
    "user_categoryFilter",
    ""
  );
  const [joinDateFilter, setJoinDateFilter] = usePersistedState(
    "user_joinDateFilter",
    null
  );
  const [leftDateFilter, setLeftDateFilter] = usePersistedState(
    "user_leftDateFilter",
    null
  );
  const [suspensionDateFilter, setSuspensionDateFilter] = usePersistedState(
    "user_suspensionDateFilter",
    null
  );
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalUsers, setTotalUsers] = useState(0);
  const token = localStorage.getItem("authToken");
  const [inputName, setInputName] = useState("");
  const [inputMobile, setInputMobile] = useState("");
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [sortField, setSortField] = useState("");
  const [sortDirection, setSortDirection] = useState("ASC"); // ASC | DESC
  const nameInputRef = useRef(null); // Add this above return
  const mobileInputRef = useRef(null);
  const codeInputRef = useRef(null);
  const [inputCode, setInputCode] = useState("");
  const [userTypeFilter, setUserTypeFilter] = usePersistedState(
    "user_roleTypeFilter",
    ""
  );

  const allowedOrderColumns = [
    "user_fullname",
    "user_mob",
    "user_code",
    "user_designation",
    "user_category",
    "join_date",
    "left_date",
    "suspension_date",
    "employmentstatus",
    "user_blocked",
  ];

  const toggleSort = (column) => {
    if (!allowedOrderColumns.includes(column)) return;
    if (sortField === column) {
      setSortDirection((prev) => (prev === "ASC" ? "DESC" : "ASC"));
    } else {
      setSortField(column);
      setSortDirection("ASC");
    }
  };

  const getSortIcon = (column) => {
    if (sortField === column) {
      return sortDirection === "ASC" ? faSortUp : faSortDown;
    }
    return faSort;
  };

  // Toggle single selection
  const toggleUserSelection = (id) => {
    setSelectedUserIds((prev) =>
      prev.includes(id) ? prev.filter((uid) => uid !== id) : [...prev, id]
    );
  };

  const handleCheckboxChange = (id) => {
    const scrollY = window.scrollY;
    toggleUserSelection(id);
    setTimeout(() => window.scrollTo(0, scrollY), 0);
  };

  // Toggle all
  const toggleSelectAll = () => {
    if (checkAll) {
      setSelectedUserIds([]);
    } else {
      setSelectedUserIds(filteredUsers.map((u) => u.id));
    }
    setCheckAll(!checkAll);
  };

  const getExportFilters = () => {
    const filterParams = {};

    if (nameFilter) filterParams.user_fullname = nameFilter;
    if (mobileFilter) filterParams.user_mob = mobileFilter;
    if (emailFilter) filterParams.user_code = emailFilter;
    if (designationFilter) filterParams.user_designation = designationFilter;
    if (categoryFilter) filterParams.user_category = categoryFilter;
    if (statusFilter) filterParams.employmentstatus = statusFilter;
    if (userTypeFilter) filterParams.user_type = userTypeFilter;
    if (joinDateFilter) {
      const date = new Date(joinDateFilter);
      date.setDate(date.getDate() + 1);
      filterParams.join_date = date.toISOString().split("T")[0];
    }
    if (leftDateFilter)
      filterParams.left_date = leftDateFilter.toISOString().split("T")[0];
    if (suspensionDateFilter)
      filterParams.suspension_date = suspensionDateFilter
        .toISOString()
        .split("T")[0];

    return filterParams;
  };

  const handleExportUser = async () => {
    try {
      setExportLoading(true);
      const computedCheckAll = selectedUserIds.length === 0 ? true : checkAll;
      const response = await axios.post(
        `${API_URL}user/export?checkAll=${computedCheckAll}`,
        {
          filters: getExportFilters(),
          selectedIds: computedCheckAll
            ? []
            : selectedUserIds.map((id) => String(id)),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            Accept: "*/*",
          },
          responseType: "blob", // important for file download
        }
      );

      // Create file download
      const contentDisposition = response.headers["content-disposition"] || "";
      let filename = "users_export.xlsx";
      const match = contentDisposition.match(
        /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i
      );
      if (match) {
        filename = decodeURIComponent(match[1] || match[2]);
      }

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setSelectedUserIds([]);
      setCheckAll(false);
      showToast.success("Users exported successfully");
    } catch (error) {
      console.error("Export failed:", error);
      // alert("Failed to export users");
      showToast.error("Failed to export users");
    } finally {
      setExportLoading(false);
    }
  };

  // Dropdown data state
  const [dropdownData, setDropdownData] = useState({
    designationlist: [],
    employmentstatuslist: [],
    employmenttypelist: [],
    languages: [],
    user_category: [],
    gender: [],
    marital_status: [],
    insentives: [],
    relationship_nominee: [],
  });



  // Fetch users from API
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const filterParams = {};

      // Apply filters to API call
      if (nameFilter) filterParams.user_fullname = nameFilter;
      if (mobileFilter) filterParams.user_mob = mobileFilter;
      if (emailFilter) filterParams.user_code = emailFilter;
      if (designationFilter) filterParams.user_designation = designationFilter;
      if (categoryFilter) filterParams.user_category = String(categoryFilter);
      if (statusFilter) filterParams.employmentstatus = statusFilter;
      if (userTypeFilter) filterParams.user_type = userTypeFilter;
      if (joinDateFilter) {
        const date = new Date(joinDateFilter);
        date.setDate(date.getDate() + 1);
        filterParams.join_date = date.toISOString().split("T")[0];
      }
      if (leftDateFilter) {
        const date = new Date(leftDateFilter);
        date.setDate(date.getDate() + 1);
        filterParams.left_date = date.toISOString().split("T")[0];
      }
      if (suspensionDateFilter) {
        const date = new Date(suspensionDateFilter);
        date.setDate(date.getDate() + 1);
        filterParams.suspension_date = date.toISOString().split("T")[0];
      }

      const response = await axios.post(
        `${API_URL}user?limit=${pageSize}&page=${page}`,
        {
          ...filterParams,
          ...(sortField && allowedOrderColumns.includes(sortField)
            ? { orderBy: sortField, orderDirection: sortDirection }
            : {}),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const fetchedUsers = Array.isArray(response.data.data.data)
        ? response.data.data.data
        : Array.isArray(response.data.data.users)
          ? response.data.data.users
          : [];
      setUsers(fetchedUsers);
      setFilteredUsers(fetchedUsers);
      const meta = response.data.data || {};
      setTotalUsers(
        typeof meta.total === "number"
          ? meta.total
          : typeof meta.filteredCount === "number"
            ? meta.filteredCount
            : typeof meta.totalCount === "number"
              ? meta.totalCount
              : 0
      );
      if (typeof meta.pageSize === "number" && meta.pageSize > 0) {
        setPageSize(meta.pageSize);
      }
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsers([]);
      setFilteredUsers([]);
      setTotalUsers(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [
    page,
    statusFilter,
    nameFilter,
    mobileFilter,
    emailFilter,
    designationFilter,
    categoryFilter,
    userTypeFilter,
    joinDateFilter,
    leftDateFilter,
    suspensionDateFilter,
    sortField,
    sortDirection,
  ]);

  // Apply client-side filtering (if needed)
  useEffect(() => {
    let filteredData = [...users];

    if (nameFilter) {
      filteredData = filteredData.filter((user) =>
        user.user_fullname?.toLowerCase().includes(nameFilter.toLowerCase())
      );
    }

    if (mobileFilter) {
      filteredData = filteredData.filter((user) =>
        user.user_mob?.toLowerCase().includes(mobileFilter.toLowerCase())
      );
    }

    if (emailFilter) {
      filteredData = filteredData.filter((user) =>
        user.user_code?.toLowerCase().includes(emailFilter.toLowerCase())
      );
    }

    if (designationFilter) {
      filteredData = filteredData.filter(
        (user) => String(user.user_designation) === String(designationFilter)
      );
    }

    if (categoryFilter) {
      filteredData = filteredData.filter(
        (user) => String(user.user_category) == String(categoryFilter)
      );
    }

    if (statusFilter) {
      filteredData = filteredData.filter(
        (user) => String(user.employmentstatus) === String(statusFilter)
      );
    }


    if (joinDateFilter) {
      filteredData = filteredData.filter((user) => {
        if (!user.join_date) return false;
        const userDate = new Date(user.join_date);
        const filterDate = new Date(joinDateFilter);
        return (
          userDate.getFullYear() === filterDate.getFullYear() &&
          userDate.getMonth() === filterDate.getMonth() &&
          userDate.getDate() === filterDate.getDate()
        );
      });
    }

    if (leftDateFilter) {
      filteredData = filteredData.filter((user) => {
        if (!user.left_date) return false;
        const userDate = new Date(user.left_date);
        const filterDate = new Date(leftDateFilter);
        return (
          userDate.getFullYear() === filterDate.getFullYear() &&
          userDate.getMonth() === filterDate.getMonth() &&
          userDate.getDate() === filterDate.getDate()
        );
      });
    }

    if (suspensionDateFilter) {
      filteredData = filteredData.filter((user) => {
        if (!user.suspension_date) return false;
        const userDate = new Date(user.suspension_date);
        const filterDate = new Date(suspensionDateFilter);
        return (
          userDate.getFullYear() === filterDate.getFullYear() &&
          userDate.getMonth() === filterDate.getMonth() &&
          userDate.getDate() === filterDate.getDate()
        );
      });
    }

    setFilteredUsers(filteredData);
  }, [
    users,
    nameFilter,
    mobileFilter,
    emailFilter,
    designationFilter,
    categoryFilter,
    statusFilter,
    joinDateFilter,
    leftDateFilter,
    suspensionDateFilter,
  ]);
  // Debounce Name Filter
  useEffect(() => {
    const timer = setTimeout(() => {
      setNameFilter(inputName.trim());
    }, 500);
    return () => clearTimeout(timer);
  }, [inputName]);

  // Debounce Mobile Filter
  useEffect(() => {
    const timer = setTimeout(() => {
      setMobileFilter(inputMobile.trim());
    }, 500);
    return () => clearTimeout(timer);
  }, [inputMobile]);

  // Debounce User Code (Email) Filter
  useEffect(() => {
    const timer = setTimeout(() => {
      setEmailFilter(inputCode.trim());
    }, 500);
    return () => clearTimeout(timer);
  }, [inputCode]);
  // Fetch dropdown data
  const fetchDropdownData = async () => {
    try {
      const response = await axios.get(`${API_URL}user/get-dropdown`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setDropdownData(response.data.data);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };

  useEffect(() => {
    fetchDropdownData();
  }, []);

  // Listen for clear filters event from sidebar
  useEffect(() => {
    const handleClearFilters = () => {
      resetFilters();
    };

    window.addEventListener('clearHRMSUserManagementFiltersEvent', handleClearFilters);

    return () => {
      window.removeEventListener('clearHRMSUserManagementFiltersEvent', handleClearFilters);
    };
  }, []);

  // Delete user
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (confirmDelete) {
      try {
        const response = await fetch(`${API_URL}user/delete-user/${id}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          setUsers(users.filter((user) => user.id !== id));
          setFilteredUsers(filteredUsers.filter((user) => user.id !== id));
          alert("User deleted successfully");
        } else {
          const errorData = await response.json();
          alert(`Error: ${errorData.message || "Failed to delete user"}`);
        }
      } catch (error) {
        console.error("Error deleting user:", error);
        alert("An error occurred while deleting the user.");
      }
    }
  };

  // Reset all filters
  const resetFilters = () => {
    setNameFilter("");
    setMobileFilter("");
    setEmailFilter("");
    setDesignationFilter("");
    setCategoryFilter("");
    setStatusFilter("");
    setUserTypeFilter("");
    setJoinDateFilter(null);
    setLeftDateFilter(null);
    setSuspensionDateFilter(null);
    setInputName("");
    setInputMobile("");
    setInputCode("");
  };

  const tableContainerRef = useRef(null);
  const fakeContainerRef = useRef(null);
  const fakeDivRef = useRef(null);

  useEffect(() => {
    const tableContainer = tableContainerRef.current;
    const fakeContainer = fakeContainerRef.current;
    const fakeDiv = fakeDivRef.current;

    if (tableContainer && fakeContainer && fakeDiv) {
      const tableWidth = tableContainer.scrollWidth;
      fakeDiv.style.width = `${tableWidth}px`;

      let isSyncing = false;
      let lastTableLeft = tableContainer.scrollLeft;
      let lastFakeLeft = fakeContainer.scrollLeft;

      const handleFakeScroll = () => {
        const left = fakeContainer.scrollLeft;
        if (left === lastFakeLeft) return;
        lastFakeLeft = left;
        if (isSyncing) return;
        if (Math.abs(tableContainer.scrollLeft - left) < 1) return;
        isSyncing = true;
        tableContainer.scrollLeft = left;
        lastTableLeft = left;
        requestAnimationFrame(() => {
          isSyncing = false;
        });
      };

      const handleTableScroll = () => {
        const left = tableContainer.scrollLeft;
        if (left === lastTableLeft) return;
        lastTableLeft = left;
        if (isSyncing) return;
        if (Math.abs(fakeContainer.scrollLeft - left) < 1) return;
        isSyncing = true;
        fakeContainer.scrollLeft = left;
        lastFakeLeft = left;
        requestAnimationFrame(() => {
          isSyncing = false;
        });
      };

      fakeContainer.addEventListener("scroll", handleFakeScroll, { passive: true });
      tableContainer.addEventListener("scroll", handleTableScroll, { passive: true });

      return () => {
        fakeContainer.removeEventListener("scroll", handleFakeScroll);
        tableContainer.removeEventListener("scroll", handleTableScroll);
      };
    }
  }, [filteredUsers]);

  // Safety check for undefined dropdown data arrays
  const isDropdownDataAvailable = (dataArray) =>
    Array.isArray(dataArray) && dataArray.length > 0;

  const startRecord = totalUsers > 0 ? (page - 1) * pageSize + 1 : 0;
  const endRecord = Math.min(page * pageSize, totalUsers);

  const formatDate = (date) => {
    if (
      !date ||
      date === "0000-00-00" ||
      date === "0000-00-00 00:00:00" ||
      date.includes("1899") ||
      date === "30/11/1899" ||
      date === "1899-11-30"
    ) {
      return "N/A";
    }

    try {
      // Parse the date
      const dateObj = new Date(date);

      // Check if date is valid
      if (isNaN(dateObj.getTime())) {
        return "N/A";
      }

      // Format to DD-MM-YYYY
      const day = String(dateObj.getDate()).padStart(2, '0');
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const year = dateObj.getFullYear();

      return `${day}-${month}-${year}`;
    } catch {
      return "N/A";
    }
  };
  return (
    <div className="panel-content mt-5">
      {/* {loading && <LoadingSpinner />} */}
      {successMessage && (
        <div className="alert alert-success">{successMessage}</div>
      )}
      <div className="panel-heading user-management-header d-flex justify-content-between align-items-center">
        <div className="header-title">
          <h4 className="panel-title">Manage User</h4>
        </div>
        <div className="header-controls d-flex align-items-center">
          <div className="action-buttons d-flex align-items-center">
            {(nameFilter ||
              mobileFilter ||
              emailFilter ||
              designationFilter ||
              categoryFilter ||
              statusFilter ||
              userTypeFilter ||
              joinDateFilter ||
              leftDateFilter ||
              suspensionDateFilter) && (
                <button
                  className="btn btn-default btn-sm mx-1"
                  onClick={resetFilters}
                  title="Reset Filters"
                >
                  Reset Filters
                </button>
              )}
            <PermissionWrapper module="hrms_user" action="add">
              <Link to="/Hrms/User/add" className="btn btn-default btn-sm mx-1">
                <FontAwesomeIcon icon={faPlus} /> Add User
              </Link>
            </PermissionWrapper>
            <button
              className="btn btn-default btn-sm mx-1"
              onClick={handleExportUser}
              disabled={exportLoading}
            >
              {exportLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Exporting...
                </>
              ) : (
                <>
                  <FontAwesomeIcon icon={faDownload} /> Export User
                </>
              )}
            </button>

          </div>
          <div className="pagination-group d-flex align-items-center ms-2">
            <span style={{ fontSize: "0.8rem" }}>
              {loading ? (
                <span className="skeleton-text" style={{ width: "160px", display: "inline-block" }}></span>
              ) : (
                <>{startRecord} to {endRecord} of {totalUsers}</>
              )}
            </span>
            <div className="pagination-nav ms-2 d-flex align-items-center">
              <button
                className="btn btn-default btn-sm"
                onClick={() => setPage(page - 1)}
                disabled={page === 1}
                title="Previous"
              >
                <FontAwesomeIcon icon={faChevronLeft} />
              </button>
              &nbsp;
              <button
                className="btn btn-default btn-sm"
                onClick={() => setPage(page + 1)}
                disabled={page * pageSize >= totalUsers}
                title="Next"
              >
                <FontAwesomeIcon icon={faChevronRight} />
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="panel panel-default with-rounded-corner with-shadow">
        <div
          className="large-table-fake-top-scroll-container-3"
          ref={fakeContainerRef}
        >
          <div ref={fakeDivRef}>&nbsp;</div>
        </div>

        <div
          className="large-table-container-3 user-table-container"
          ref={tableContainerRef}
        >
          <table className="table table-condensed table-hover bg-white">
            <thead>
              <tr style={{ cursor: "pointer" }}>
                <th></th>
                <FieldPermissionWrapper field="user_fullname">
                  <th
                    className="fixed-column-name"
                    onClick={() => toggleSort("user_fullname")}
                  >
                    Name <FontAwesomeIcon icon={getSortIcon("user_fullname")} />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_personal_mobile">
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => toggleSort("user_mob")}
                  >
                    Mobile No <FontAwesomeIcon icon={getSortIcon("user_mob")} />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_code">
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => toggleSort("user_code")}
                  >
                    User Code{" "}
                    <FontAwesomeIcon icon={getSortIcon("user_code")} />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_designation">
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => toggleSort("user_designation")}
                  >
                    Designation{" "}
                    <FontAwesomeIcon icon={getSortIcon("user_designation")} />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_category">
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => toggleSort("user_category")}
                  >
                    Category{" "}
                    <FontAwesomeIcon icon={getSortIcon("user_category")} />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_join_date">
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => toggleSort("join_date")}
                  >
                    Join Date{" "}
                    <FontAwesomeIcon icon={getSortIcon("join_date")} />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_left_date">
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => toggleSort("left_date")}
                  >
                    Left Date{" "}
                    <FontAwesomeIcon icon={getSortIcon("left_date")} />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_suspension_date">
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => toggleSort("suspension_date")}
                  >
                    Suspension Date{" "}
                    <FontAwesomeIcon icon={getSortIcon("suspension_date")} />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_employmentstatus">
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => toggleSort("employmentstatus")}
                  >
                    Employment Status{" "}
                    <FontAwesomeIcon icon={getSortIcon("employmentstatus")} />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_role">
                  <th>User Role</th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_blocked">
                  <th
                    style={{ minWidth: "155px", cursor: "pointer" }}
                    onClick={() => toggleSort("user_blocked")}
                  >
                    Status{" "}
                    <FontAwesomeIcon icon={getSortIcon("user_blocked")} />
                  </th>
                </FieldPermissionWrapper>
                <th className="fixed-column-actions">Actions</th>
              </tr>
              {/* Filter Row */}
              <tr>
                <th></th>
                <FieldPermissionWrapper field="user_fullname">
                  <th className="fixed-column-name">
                    <input
                      type="text"
                      placeholder="Search by Name"
                      ref={nameInputRef}
                      value={inputName}
                      onChange={(e) => setInputName(e.target.value)}
                    />
                  </th>
                </FieldPermissionWrapper>

                <FieldPermissionWrapper field="user_personal_mobile">
                  <th>
                    <input
                      type="text"
                      placeholder="Search by Mobile"
                      ref={mobileInputRef}
                      value={inputMobile}
                      onChange={(e) => setInputMobile(e.target.value)}
                    />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_code">
                  <th>
                    <input
                      type="text"
                      placeholder="Search by User Code"
                      ref={codeInputRef}
                      value={inputCode}
                      onChange={(e) => setInputCode(e.target.value)}
                    />
                  </th>
                </FieldPermissionWrapper>

                <FieldPermissionWrapper field="user_designation">
                  <th>
                    <select
                      value={designationFilter}
                      onChange={(e) => setDesignationFilter(e.target.value)}
                    >
                      <option value="">Select Designation</option>
                      {isDropdownDataAvailable(dropdownData.designationlist) &&
                        dropdownData.designationlist.map((designation) => (
                          <option
                            key={designation.id || designation._id || designation.pick_id}
                            value={designation.id || designation._id || designation.pick_id}
                          >
                            {designation.pick_name}
                          </option>
                        ))}
                    </select>
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_category">
                  <th>
                    <select
                      value={categoryFilter}
                      onChange={(e) => setCategoryFilter(e.target.value)}
                    >
                      <option value="">Select Category</option>
                      {isDropdownDataAvailable(dropdownData.user_category) &&
                        dropdownData.user_category.map((category) => (
                          <option
                            key={category.id || category._id}
                            value={category.id || category._id}
                          >
                            {category.name}
                          </option>
                        ))}
                    </select>
                  </th>
                </FieldPermissionWrapper>

                <FieldPermissionWrapper field="user_join_date">
                  <th>
                    {/* <DatePicker
                      selected={joinDateFilter}
                      onChange={(date) => {
                        setJoinDateFilter(date);
                        setPage(1);
                      }}
                      isClearable
                      placeholderText="Select Join Date"
                      dateFormat="yyyy-MM-dd"
                      showYearDropdown
                      showMonthDropdown // ✅ allow month change
                      dropdownMode="select" // ✅ dropdown for both month/year
                      scrollableYearDropdown
                      yearDropdownItemNumber={15}
                    /> */}
                    <DatePicker
                      selected={joinDateFilter}
                      onChange={(date) => {
                        setJoinDateFilter(date);
                        setPage(1);
                      }}
                      isClearable
                      placeholderText="Select Join Date"
                      dateFormat="dd-MM-yyyy"
                      openToDate={joinDateFilter}
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                      scrollableYearDropdown
                      yearDropdownItemNumber={15} // ✅ Shows 15 years in dropdown
                    // minDate={new Date(2018, 0, 1)} // ✅ Start from 2018
                    // maxDate={new Date(2030, 11, 31)} // ✅ Up to 2030
                    />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_left_date">
                  <th>
                    <DatePicker
                      selected={leftDateFilter}
                      onChange={(date) => {
                        setLeftDateFilter(date);
                        setPage(1);
                      }}
                      isClearable
                      placeholderText="Select Left Date"
                      dateFormat="dd-MM-yyyy"
                      openToDate={leftDateFilter}
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                      scrollableYearDropdown
                      yearDropdownItemNumber={15} // ✅ Shows 15 years in dropdown
                    // minDate={new Date(2018, 0, 1)} // optional
                    // maxDate={new Date(2030, 11, 31)} // optional
                    />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_suspension_date">
                  <th>
                    <DatePicker
                      selected={suspensionDateFilter}
                      onChange={(date) => {
                        setSuspensionDateFilter(date);
                        setPage(1);
                      }}
                      isClearable
                      placeholderText="Select Suspension Date"
                      dateFormat="dd-MM-yyyy"
                      openToDate={suspensionDateFilter}
                      showYearDropdown
                      showMonthDropdown
                      dropdownMode="select"
                      scrollableYearDropdown
                      yearDropdownItemNumber={15}
                    // minDate={new Date(2018, 0, 1)} // optional
                    // maxDate={new Date(2030, 11, 31)} // optional
                    />
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_employmentstatus">
                  <th>
                    <select
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                    >
                      <option value="">Select Status</option>
                      {isDropdownDataAvailable(
                        dropdownData.employmentstatuslist
                      ) &&
                        dropdownData.employmentstatuslist.map((status) => (
                          <option
                            key={status.id || status._id || status.pick_id}
                            value={status.id || status._id || status.pick_id}
                          >
                            {status.pick_name}
                          </option>
                        ))}
                    </select>
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_role">
                  <th>
                    <select
                      value={userTypeFilter}
                      onChange={(e) => setUserTypeFilter(e.target.value)}
                    >
                      <option value="">Select User Type</option>
                      {isDropdownDataAvailable(dropdownData.userroles) &&
                        dropdownData.userroles.map((role) => (
                          <option key={role.id} value={role.id}>
                            {role.user_role}
                          </option>
                        ))}
                    </select>
                  </th>
                </FieldPermissionWrapper>
                <FieldPermissionWrapper field="user_blocked">
                  <th></th>
                </FieldPermissionWrapper>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                // Skeleton loading rows (initial load + filter apply)
                Array.from({ length: 10 }).map((_, skeletonIndex) => (
                  <tr key={`skeleton-${skeletonIndex}`} className="skeleton-row">
                    <td className="fixed-column-checkbox">
                      <div className="skeleton-text" style={{ width: "20px" }}></div>
                    </td>
                    <td className="fixed-column-name">
                      <div className="skeleton-text" style={{ width: "80%" }}></div>
                    </td>
                    <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "75%" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "65%" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "65%" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "65%" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "70%" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "60%" }}></div></td>
                    <td><div className="skeleton-text" style={{ width: "50%" }}></div></td>
                    <td>
                      <div className="skeleton-text" style={{ width: "80%" }}></div>
                    </td>
                  </tr>
                ))
              ) : Array.isArray(filteredUsers) && filteredUsers.length > 0 ? (
                filteredUsers.map((user) => (
                  <tr key={user.id}>
                    <td className="fixed-column-checkbox">
                      <input
                        type="checkbox"
                        checked={selectedUserIds.includes(user.id)}
                        onChange={() => handleCheckboxChange(user.id)}
                      />
                    </td>

                    <FieldPermissionWrapper field="user_fullname">
                      <td className="fixed-column-name" style={{ cursor: "pointer" }}>
                        <a
                          href={`/profile/${user?.id || "#"}`}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            user?.id
                              ? navigate(`/profile/${user.id}`)
                              : showToast.warning("User ID not found for this record");
                          }}
                          style={{
                            color: "#0d6efd",
                            textDecoration: "none",
                            display: "block",
                            width: "100%",
                          }}
                        >
                          {user.user_fullname}
                        </a>
                      </td>
                    </FieldPermissionWrapper>

                    <FieldPermissionWrapper field="user_personal_mobile">
                      <td>{user.user_mob}</td>
                    </FieldPermissionWrapper>

                    <FieldPermissionWrapper field="user_code">
                      <td>{user.user_code}</td>
                    </FieldPermissionWrapper>

                    <FieldPermissionWrapper field="user_designation">
                      <td>
                        {dropdownData.designationlist.find(
                          (d) =>
                            String(d.id || d._id || d.pick_id) ===
                            String(user.user_designation)
                        )?.pick_name || user.user_designation}
                      </td>
                    </FieldPermissionWrapper>

                    <FieldPermissionWrapper field="user_category">
                      <td>
                        {dropdownData.user_category.find(
                          (c) =>
                            String(c.id || c._id) === String(user.user_category)
                        )?.name || user.user_category}
                      </td>
                    </FieldPermissionWrapper>

                    <FieldPermissionWrapper field="user_join_date">
                      <td>
                        {formatDate(user.join_date)}
                      </td>
                    </FieldPermissionWrapper>

                    <FieldPermissionWrapper field="user_left_date">
                      <td>
                        {formatDate(user.left_date)}
                      </td>
                    </FieldPermissionWrapper>

                    <FieldPermissionWrapper field="user_suspension_date">
                      <td>
                        {formatDate(user.suspension_date)}
                      </td>
                    </FieldPermissionWrapper>

                    <FieldPermissionWrapper field="user_employmentstatus">
                      <td>
                        {dropdownData.employmentstatuslist.find(
                          (s) =>
                            String(s.id || s._id || s.pick_id) ===
                            String(user.employmentstatus)
                        )?.pick_name || user.employmentstatus}
                      </td>
                    </FieldPermissionWrapper>


                    <FieldPermissionWrapper field="user_role">
                      <td>
                        {dropdownData.userroles?.find(
                          (r) => r.id == user.user_type
                        )?.user_role || user.role_type || user.user_type || "N/A"}
                      </td>
                    </FieldPermissionWrapper>

                    <FieldPermissionWrapper field="user_blocked">
                      <td>
                        <span
                          style={{
                            padding: "5px 12px",
                            borderRadius: "6px",
                            color: "#fff",
                            fontWeight: "bold",
                            backgroundColor:
                              user.user_blocked === 0 ? "red" : "dodgerblue",
                          }}
                        >
                          {user.user_blocked === 0 ? "Deactivated" : "Activated"}
                        </span>
                      </td>
                    </FieldPermissionWrapper>

                    <td className="d-flex fixed-column-actions gap-2">
                      <PermissionWrapper module="hrms_user" action="edit">
                        <Link
                          to={`/Hrms/User/edit/${user.id}`}
                          className="btn btn-warning btn-xs"
                        >
                          <FontAwesomeIcon icon={faPencil} />
                        </Link>
                      </PermissionWrapper>

                      {hasPermission("hrms_user", "edit") &&
                        hasPermission("view_as_team_manager", "view") &&
                        user.user_type === 3 && (
                          <Link
                            to={`/Hrms/User/addSubuser/${user.id}`}
                            className="btn btn-primary btn-xs"
                          >
                            <FontAwesomeIcon icon={faPencil} />
                          </Link>
                        )}

                      <PermissionWrapper module="hrms_user" action="delete">
                        <button
                          className="btn btn-danger btn-xs"
                          onClick={() => handleDelete(user.id)}
                        >
                          <FontAwesomeIcon icon={faTrash} />
                        </button>
                      </PermissionWrapper>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="13" style={{ textAlign: "center" }}>
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="13">
                  <span style={{ fontSize: "0.8rem" }}>
                    {startRecord} to {endRecord} of {totalUsers}
                  </span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UserManagement;
